if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification && typeof cartNotification.setActiveElement === 'function') {
          cartNotification.setActiveElement(this.openedBy);
        }
        
        // Reset contents cleanly on close so it can fetch cleanly next time
        if (this.modalContent) this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        if (!opener || !opener.getAttribute('data-product-url')) return;
        
        this.openedBy = opener;
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        
        const spinner = opener.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        // Always fetch fresh content to allow repeated openings flawlessly
        fetch(`${opener.getAttribute('data-product-url')}${opener.getAttribute('data-product-url').includes('?') ? '&' : '?'}view=quick-add`)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            let productElement = responseHTML.querySelector('product-info');

            // Fallback to layout general standard wrapper if view section template variation lacks wrapper 
            if (!productElement) productElement = responseHTML.querySelector('.product');

            if (!productElement) {
              console.error('Quick Add Error: product content structure not found.');
              return;
            }

            this.preprocessHTML(productElement);
            
            if (typeof HTMLUpdateUtility !== 'undefined' && HTMLUpdateUtility.setInnerHTML) {
              HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            } else {
              this.modalContent.innerHTML = productElement.outerHTML;
            }

            // Explicitly force lifecycle boot up for internal components inside the popup 
            const productInfo = this.modalContent.querySelector('product-info');
            if (productInfo) {
              if (typeof productInfo.initialize === 'function') productInfo.initialize();
              
              productInfo.dispatchEvent(
                new CustomEvent('product-info:loaded', { bubbles: true })
              );
            }

            // Sync selectors and picks
            const variantRadios = this.modalContent.querySelectorAll('variant-radios, variant-selects');
            variantRadios.forEach((picker) => picker.dispatchEvent(new Event('change')));

            if (window.Shopify?.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            // Display popup through core component helper natively
            super.show(opener);
          })
          .catch((error) => {
            console.error('Quick Add Fetch error:', error);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        if (!productElement) return;
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient') {
            if (this.modalContent) this.modalContent.classList.add(classApplied);
          }
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        productElement.querySelectorAll('pickup-availability, product-modal, modal-dialog').forEach((el) => el.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section || 'quickadd';
        const newId = `quickadd-${sectionId}-${Math.floor(Math.random() * 10000)}`;
        
        productElement.innerHTML = productElement.innerHTML.replaceAll(sectionId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(sectionId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(sectionId, newId));
          }
        });
        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        if (!product || !product.classList.contains('product--columns')) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }
        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}